const COMPONENT_PREFIX = "one-bill-details";

export const ONE_BILL_DETAILS_TEST_IDS = {
    ONE_LOGO: `${COMPONENT_PREFIX}-oneplus-logo`,
    ONE_LITE_LOGO: `${COMPONENT_PREFIX}-onelite-logo`,
};
